import {
  takeLatest, put, call, select,
} from 'redux-saga/effects';
import actionTypes2 from 'store/table2/actionTypes2';
import api from 'store/api';
import { toast } from 'react-toastify';
import { URL } from '../../../constants/url';
import {
  getBb, getGgps, getStake, getTs,
} from '../selectors';
import { setFirstPairCardTableFold2 } from '../actions';

export function* setFirstPair(payload) {
  const ts = yield select(getTs);
  const stake = yield select(getStake);
  const bb = yield select(getBb);
  const ggps = yield select(getGgps);

  try {
    const res = yield call(api, {
      method: 'post',
      url: sessionStorage.getItem('isPlo5') === 'true' ? URL.PLO5FIRST_PAIR : URL.FIRST_PAIR,
      data: {
        ts,
        // eslint-disable-next-line no-nested-ternary
        bb: ts !== 'mtt' ? (stake.includes('0') ? 'rfivssqz' : bb) : `${bb}potopen`,
        stake,
        easy: payload.easy,
        game: payload.gameTable,
        smart_range: payload.smartRange,
        gg: ggps === 'gg',
      },
    });

    const { data } = res;
    yield put(setFirstPairCardTableFold2.success({
      cells: data?.cells,
      purple: data?.purple,
    }));
  } catch (e) {
    yield call(toast.error, e.message);
    yield put(setFirstPairCardTableFold2.error({
      e,
    }));
  }
}

export default function* listener() {
  yield takeLatest(actionTypes2.SET_FIRST_PAIR_2, setFirstPair);
}
